import React from 'react'
import { Box, Typography } from '@mui/material'

import { isAnalyzerLoading } from 'Pages/AnalyzersV2/@signals'
import { buildPositionKpis } from 'Pages/AnalyzersV2/@components/PositionKpis/@utils'
import { MbKpiCard, MbKpiRow, MbKpiSkeleton } from 'Pages/MyBusiness/_shared/Ui'
import { dsColorNew } from '@palette'


// The five header figures as the app's figure cards (Main Page, My Business, DS Repricing)
export default function PositionKpis({ mainData, currency }) {
	if (isAnalyzerLoading.value) return <MbKpiSkeleton count={5}/>

	const kpis = buildPositionKpis(mainData, currency)

	if (!kpis.length) return null

	return <MbKpiRow>
		{kpis.map(({ key, label, value, unit, note, color, noteColor }) => <MbKpiCard
			key={key}
			label={label}
			value={<Box component="span" sx={{ display: 'inline-flex', alignItems: 'baseline', gap: .5 }}>
				<Box component="span" sx={{ color: color || dsColorNew.textTitle }}>{value}</Box>
				{!!unit && <Box component="span" sx={{ fontSize: 15, fontWeight: 500, color: dsColorNew.textSubtle }}>
					{unit}
				</Box>}
			</Box>}
		>
			<Typography sx={{ fontSize: 12.5, mt: 1, color: noteColor || dsColorNew.textMuted, fontWeight: noteColor ? 600 : 400 }}>
				{note}
			</Typography>
		</MbKpiCard>)}
	</MbKpiRow>
}
